import { render, staticRenderFns } from "./leads_follow_count.vue?vue&type=template&id=3c372f72&scoped=true&"
import script from "./leads_follow_count.vue?vue&type=script&lang=js&"
export * from "./leads_follow_count.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c372f72",
  null
  
)

export default component.exports